<template>
  <div class="intersetGroupDetail">
    <!--控制范围信息-->
    <el-form ref="intersetGroupDetail" label-position="right" label-width="100px" :model="detail">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="部门组编码">
            <el-input v-model="detail.interestGroupCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门组名称">
            <el-input v-model="detail.interestGroupName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计息公司">
            <el-input v-model="detail.interestCompanyName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计息公司编码">
            <el-input v-model="detail.interestCompanyCode" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
    <sirui-table
      ref="siruiTable"
      :buttonList="[]"
      :loading="false"
      :data="tableData"
      :paging="false"
      :setting="false"
      :reserve="false"
    >
      <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </sirui-table>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';

  export default {
    name: 'intersetGroupDetail',
    components: {
      SiruiTable,
    },
    data() {
      return {};
    },
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      columnList() {
        return [
          {
            prop: 'interestDepartmentCode',
            label: '部门编码',
          },
          {
            prop: 'interestDepartmentName',
            label: this.$t('company.table.departmentName'),
          },
          {
            prop: 'inDate',
            label: '调整部门组日期',
          },
          {
            prop: 'outDate',
            label: '离开部门组日期',
          },
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
